// Copyright (c) 2016 Deere & Company

import KeyValuePair from './key-value-pair';
import t from 'tcomb';

const KeyValuePairCollection = t.list(KeyValuePair, 'KeyValuePairCollection');

export const getDefaultState = () => new KeyValuePairCollection([]);

export default KeyValuePairCollection;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection.js